import EventClass from "common/utils/ui/event-class";
import { track } from "jiffy-analytics";

export class DigitalAssetsShowMoreFilters extends EventClass {
  #openSectionsHash = {};

  constructor({ eventSelector }) {
    super({ eventSelector });
  }

  #isOpen(sectionId) {
    return this.#openSectionsHash[sectionId];
  }

  #toggleOpenHashSection(sectionId) {
    this.#openSectionsHash[sectionId] = !this.#openSectionsHash[sectionId];
  }

  #toggleSectionVisibility(sectionId) {
    const $hiddenSection = document.querySelector(`[data-section-hidden-id=${sectionId}]`);
    $hiddenSection?.classList.toggle("hidden", !this.#isOpen(sectionId));
  }

  #toggleActiveClassButton($button, sectionId) {
    $button.classList.toggle("active", this.#isOpen(sectionId));
  }

  #trackToggleEvent(sectionId, sectionName) {
    track("digital_asset_show_more_filters", {
      is_open: this.#isOpen(sectionId),
      section_name: sectionName
    });
  }

  event({ target }) {
    const { sectionId, sectionName } = target.dataset;
    this.#toggleOpenHashSection(sectionId);
    this.#toggleSectionVisibility(sectionId);
    this.#toggleActiveClassButton(target, sectionId);
    this.#trackToggleEvent(sectionId, sectionName);
  }
}

export default () =>
  new DigitalAssetsShowMoreFilters({ eventSelector: ".js-digital-assets-filters-toggle-button" });
